<template>
    <div>
        <div class="text-center mb-3">
            <img :src="avatar_image_path ? avatar_image_path : '/images/user-4.jpg'"
                 @click="addAvatar"
                 class="img-thumbnail avatar-image"
                 data-holder-rendered="true">
            <input @change="onAvatarChange"
                   accept="image/*"
                   ref="avatarFileInput"
                   type='file'
                   v-show="false"/>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Name:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('name') }"
                       class="form-control"
                       placeholder="Enter name"
                       title="Name"
                       type="text"
                       v-model="form.name">
                <ul :class="{'filled' : form.errors.has('name')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('name') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Email:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('email') }"
                       class="form-control"
                       placeholder="Enter email"
                       title="Email"
                       type="email"
                       v-model="form.email">
                <ul :class="{'filled' : form.errors.has('email')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('email') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Phone number:</label>
            <div class="col-sm-7 col-lg-8">
                <input :class="{ 'parsley-error' : form.errors.has('phone_number') }"
                       class="form-control"
                       placeholder="Enter phone number"
                       title="Phone number"
                       type="text"
                       v-model="form.phone_number"
                       @input="handlePhoneNumberInput">
                <ul :class="{'filled' : form.errors.has('phone_number')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('phone_number') }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-lg-4 col-form-label">Role:</label>
            <div class="col-sm-7 col-lg-8">
                <select :class="{ 'parsley-error' : form.errors.has('role') }" class="form-control"
                        title="role"
                        v-model="form.role">
                    <option :value="null" disabled>Select role</option>
                    <option :value="Roles.dealer_principle">Dealer principle</option>
                    <option :value="Roles.sales_manager">Sales manager</option>
                    <option :value="Roles.sales_person">Salesperson</option>
                </select>
                <ul :class="{'filled' : form.errors.has('role')}"
                    class="parsley-errors-list">
                    <li class="parsley-required">
                        {{ form.errors.get('role') }}
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="user">
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">New Password:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('password') }"
                           class="form-control"
                           placeholder="Enter new password"
                           title="New Password"
                           type="password"
                           v-model="form.password">
                    <ul :class="{'filled' : form.errors.has('password')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('password') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Confirm New Password:</label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('password_confirmation') }"
                           class="form-control"
                           placeholder="Confirm new password"
                           title="Confirm New Password"
                           type="password"
                           v-model="form.password_confirmation">
                    <ul :class="{'filled' : form.errors.has('password_confirmation')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('password_confirmation') }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="mt-5 text-center">
            <button @click="goTo(
                hasRole(Roles.admin) ? Routes.company_users : Routes.user,
                hasRole(Roles.admin) ? { company_id: form.company_id } : {}
                )"
                    class="btn btn-secondary waves-effect waves-light"
                    type="button">
                <i class="mdi mdi-close"/>
                Back to List
            </button>
            <button :disabled="form.busy"
                    @click="submit"
                    class="btn btn-primary waves-effect waves-light" type="button">
                <i class="mdi mdi-content-save"/>
                Submit
            </button>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";
    import Roles from "@/constants/roles";
    import User from "@/models/user";
    import AuthUtils from "@/utils/auth";
    import { validatePhoneNumber } from "@/utils/validation";

    export default {
        props: {
            user: {
                type: Object
            }
        },
        data() {
            let rules = {
                name: 'required|string|max:255',
                email: 'required|email',
                phone_number: 'string|max:50',
                role: 'required|in:' + _.join(_.map(Roles, (item) => {
                    return item
                }), ',')
            };
            if (this.user) {
                rules['password'] = 'string|min:6|confirmed'
            }
            if (AuthUtils.hasRole(Roles.admin)) {
                rules['company_id'] = 'required|integer'
            }
            return {
                Routes,
                Roles,
                form: new Form({
                    id: null,
                    name: null,
                    email: null,
                    phone_number: null,
                    role: null,
                    password: null,
                    password_confirmation: null,
                    company_id: null,
                    avatar: null,
                }, rules),
                avatar_image_path: null,
            }
        },
        mounted() {
            if (this.user) {
                this.form = _.extend(this.form, _.pick(this.user, ['id', 'name', 'email', 'phone_number']));
                this.avatar_image_path = this.user.avatar;

                if (this.user.roles.length) {
                    this.form.role = this.user.roles[0].name
                }
            }
            if (this.$route.query.company_id) {
                this.form.company_id = this.$route.query.company_id;
            }
        },
        methods: {
            addAvatar() {
                this.$refs.avatarFileInput.click();
            },
            onAvatarChange(e) {
                if (!e.target.files.length) {
                    return;
                }
                this.form.avatar = e.target.files[0];
                this.avatar_image_path = URL.createObjectURL(this.form.avatar);
            },
            submit() {
                this.form.validate()
                    .then(() => {
                        let user = new User(this.form);
                        if (!this.user) {
                            App.postData('/web-api/user', this.form)
                                .then(() => {
                                    this.form.clearFields();
                                    this.avatar_image_path = null;
                                    this.$refs.avatarFileInput.value = null;
                                    this.form.company_id = this.$route.query.company_id;
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Successfully created new user.',
                                        type: 'success'
                                    });
                                })
                        } else {
                            this.$confirm('Are you sure to save changes?', 'Confirm', {
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Cancel',
                                type: 'info'
                            }).then(() => {
                                App.putData('/web-api/user/' + this.user.id, this.form)
                                    .then(() => {
                                        this.form.password = null;
                                        this.form.password_confirmation = null;
                                        this.$notify({
                                            title: 'Success',
                                            message: 'Successfully updated user.',
                                            type: 'success'
                                        });
                                    })
                            });
                        }
                    })
            },
            goTo(route_name, params = {}) {
                this.$router.push({
                    name: route_name,
                    params
                })
            },
            handlePhoneNumberInput() {
                this.form.phone_number = validatePhoneNumber(this.form.phone_number);
            },
        },
    }
</script>

<style lang="scss" scoped>
.avatar-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
}
</style>
